import { AxiosResponse } from 'axios'
import {
  ApiSuccessResponse,
  TableResponse,
  Team,
  TeamCreateRequest,
  TeamMember,
  TeamMemberCreateRequest,
  TeamMemberRemoveRequest,
  TeamMembersRequest,
  TeamUpdateRequest,
} from 'types'
import axiosInstance from './axios'

export const getTeams = async () => {
  return axiosInstance.post<void, TableResponse<Team>>('/v2/care-teams')
}

export const getTeamMembers = async (data: TeamMembersRequest) => {
  return axiosInstance.post<TeamMembersRequest, TableResponse<TeamMember>>(
    '/v2/care-teams/members',
    data,
  )
}

export const createTeam = async (data: TeamCreateRequest) => {
  return axiosInstance.post<TeamCreateRequest, AxiosResponse<Team>>('/v2/care-teams/create', data)
}

export const updateTeam = async (data: TeamUpdateRequest) => {
  return axiosInstance.post<TeamUpdateRequest, AxiosResponse<Team>>('/v2/care-teams/update', data)
}

export const createTeamMember = async (data: TeamMemberCreateRequest) => {
  return axiosInstance.post<TeamMemberCreateRequest, AxiosResponse<TeamMember>>(
    '/v2/care-teams/add-member',
    data,
  )
}

export const removeTeamMember = async (data: TeamMemberRemoveRequest) => {
  return axiosInstance.post<TeamMemberRemoveRequest, ApiSuccessResponse>(
    '/v2/care-teams/delete-member',
    data,
  )
}
